import React from 'react';
import { Box, Typography } from '@mui/material';
import { APP_VERSION } from '../../version';

/**
 * Shared two-panel shell for the unauthenticated auth screens (login, change
 * password, MFA challenge/setup). Keeps the dark branding panel + centered
 * white card consistent without duplicating ~140 lines per page.
 */
const AuthLayout = ({ children }) => (
  <Box sx={{ display: 'flex', minHeight: '100vh' }}>
    {/* Left Panel - Branding */}
    <Box
      sx={{
        flex: '0 0 45%',
        bgcolor: '#2C3E50',
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        px: 8,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          opacity: 0.04,
          backgroundImage:
            'radial-gradient(circle at 25% 25%, #fff 1px, transparent 1px), radial-gradient(circle at 75% 75%, #fff 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <Typography
          sx={{
            fontSize: { md: '3.5rem', lg: '4.5rem' },
            fontWeight: 700,
            color: '#fff',
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            mb: 2,
          }}
        >
          Biztimize
        </Typography>
        <Typography
          sx={{
            fontSize: { md: '1rem', lg: '1.15rem' },
            color: 'rgba(255,255,255,0.6)',
            fontWeight: 400,
            maxWidth: 420,
          }}
        >
          Optimize your Business
        </Typography>
      </Box>
      <Typography
        sx={{
          position: 'absolute',
          bottom: 32,
          left: 0, right: 0,
          textAlign: 'center',
          fontSize: '0.8rem',
          color: 'rgba(255,255,255,0.3)',
        }}
      >
        &copy; {new Date().getFullYear()} Biztimize. All rights reserved. &nbsp;v{APP_VERSION}
      </Typography>
    </Box>

    {/* Right Panel - Content */}
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#EEF2F7',
        px: { xs: 3, sm: 6 },
        py: 4,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default AuthLayout;
